exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* .containerKanbanBoard {\n    overflow-x: auto;\n} */\n\n.containerKanbanBoard__details-module___tw5vo {\n  /* max-height: 100vh;  */\n}\n", ""]);

// Exports
exports.locals = {
	"containerKanbanBoard": "containerKanbanBoard__details-module___tw5vo"
};